import {SubscriptionRepository} from '@domain/model/Account/Subscription/SubscriptionRepository';
import {SubscriptionDTO} from '@domain/model/Account/Subscription/SubscriptionDTO';

const SkipMonth =
  (subscriptionRepository: SubscriptionRepository): (() => Promise<SubscriptionDTO | null>) =>
  (): Promise<SubscriptionDTO | null> => {
    return subscriptionRepository.skipMonth();
  };

export {SkipMonth};
